import React, { ReactElement } from "react";
// @ts-ignore
import { Helmet } from "react-helmet";

interface Props {
  title: string;
  children: ReactElement;
}

/**
 * @param {object} props - Component props
 * @param {string} props.title - Title of the route
 * @param {Component} props.children - Child components
 * @returns {JSX.Element} - RouteTitle component
 */
export default function RouteTitle({ title, children }: Props){
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </>
  );
};
